import _get from "lodash/get";

export const handleGet = async ({
    getApiCall,
    setIsLoading,
    setIsLoggedIn = () => {},
    setError,
    setData = () => {},
    dataTransform = data => data,
}) => {
    setIsLoading(true);

    const response = await getApiCall();

    if (_get(response, "error")) {
        if (_get(response, "error.status") === 401) {
            setIsLoggedIn(false);
        } else {
            setIsLoggedIn(true);
            setError(_get(response, "error"));
        }
    } else {
        setIsLoggedIn(true);
        const success = _get(response, "success");
        setData(dataTransform(success.data));
    }

    setIsLoading(false);

    return response;
};

export const handlePost = async ({
    postApiCall,
    setIsLoggedIn = () => {},
    setError = () => {},
    setIsSubmissionComplete = () => {},
}) => {
    setIsSubmissionComplete(false);

    const response = await postApiCall();

    const error = _get(response, "error");
    const success = _get(response, "success");

    if (error) {
        if (_get(response, "error.status") === 401) {
            setIsLoggedIn(false);
        } else {
            setIsLoggedIn(true);
            setError(_get(response, "error"));
        }

        return error;
    } else {
        setIsLoggedIn(true);
        setIsSubmissionComplete(true);

        return success;
    }
};

export default handleGet;
